export default __webpack_public_path__ + "static/media/aviaoAurea.8d8d4138.png";